import React from "react";
import { Link } from "react-router-dom";
import { REGISTER_URL, LOGIN_URL, CONTACT_EMAIL, SUPPORT_EMAIL, COMPANY } from "../../data/content";
import { OPEN_SETTINGS_EVENT } from "../../lib/consent";

export default function Footer() {
  return (
    <footer data-testid="footer-container">
      <div className="wrap">
        <div className="foot-grid">
          <div>
            <img className="light-only" src="/brand/barlo-lockup-ink.png" alt="Barlo" width="900" height="233" loading="lazy" />
            <img className="dark-only" src="/brand/barlo-lockup-cream.png" alt="Barlo" width="900" height="233" loading="lazy" />
            <p className="foot-tag">Less counting. Better margins.</p>
            <p style={{ marginTop: 10, maxWidth: "24em" }}>
              Bar stock control and supplier ordering for UK independent bars, pubs and restaurants.
            </p>
          </div>
          <div>
            <h2 className="foot-h">Product</h2>
            <ul>
              <li><Link to="/features">Features</Link></li>
              <li><Link to="/pricing">Pricing</Link></li>
              <li><Link to="/bar-gp-calculator">Free GP calculator</Link></li>
              <li><a href={REGISTER_URL}>Start free trial</a></li>
              <li><a href={LOGIN_URL}>Log in</a></li>
            </ul>
          </div>
          <div>
            <h2 className="foot-h">Company</h2>
            <ul>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/faq">FAQ</Link></li>
              <li><a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a></li>
              <li><a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a></li>
            </ul>
          </div>
          <div>
            <h2 className="foot-h">Legal</h2>
            <ul>
              <li><Link to="/privacy">Privacy</Link></li>
              <li><Link to="/terms">Terms</Link></li>
              <li><Link to="/refund-policy">Cancellation and billing</Link></li>
              <li>
                <button type="button" className="link-btn" onClick={() => window.dispatchEvent(new Event(OPEN_SETTINGS_EVENT))} data-testid="footer-cookie-settings">
                  Cookie settings
                </button>
              </li>
            </ul>
          </div>
        </div>
        <p className="legal">
          © 2026 {COMPANY.legalName}. Barlo is a trading name of {COMPANY.legalName}. Registered in England and Wales,
          company number {COMPANY.number}. Registered office: {COMPANY.office}. ICO registration number {COMPANY.ico}.
        </p>
      </div>
    </footer>
  );
}
